import BookingsAdapter from './base';

export default class Event extends BookingsAdapter {
  modelNamePlural = 'events';
}
